




















import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
} from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { adminRouterName } from '@/renderer/scripts/utils/tools';
import { CoSyncCenterEvent } from '@/renderer/scripts/CoSync/SyncCenter/CoSyncCenterEvent';
import { SyncTaskUIStatus } from '@/renderer/scripts/CoSync/SyncCenter/SyncCenter';
import { CoSyncStatus } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncEvent';
import sysNotifications from '@/renderer/scripts/utils/SysNotifications';
import { NotificationsCLickInfo, NotificationsType, SysNotificationsEevnet } from '@/common/SysNotificationsDataDefine';
import { CoSyncInfo, getName } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';
import { coSync } from '@/renderer/scripts/CoSync/coSync';
import { syncCenterEventBus } from '@/renderer/scripts/CoSync/SyncCenter/SyncCenterEventBus';
import store from '@/renderer/store';
import {
  ClickAreaInConflictNotification,
  CoSyncReporter,
} from '@/renderer/views/desktop/FileManagement/FileSync/composition/CoSyncReporter';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';

export default defineComponent({
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;

    const notificationContent = ref('');
    const conflictArray = ref<Array<number>>([]);

    const innerShow = computed(() => {
      return (
        conflictArray.value.length > 0 &&
        !vm.$route.path?.includes('fileSync') &&
        !adminRouterName.includes(vm.$route.name as string)
      );
    });

    const onCancel = () => {
      conflictArray.value = [];
      CoSyncReporter.getInstance().reportConflictNotificationClick(ClickAreaInConflictNotification.Ignore);
    };

    const onConfirm = () => {
      CoSyncReporter.getInstance().reportConflictNotificationClick(ClickAreaInConflictNotification.ShowDetail);
      conflictArray.value = [];
      const query = {
        from: 'conflictNotification',
      };
      dispatchRouter({ name: 'fileSync', query });
    };

    const initData = (statusMap?: Map<number, SyncTaskUIStatus>) => {
      conflictArray.value = [];
      statusMap?.forEach((element: SyncTaskUIStatus) => {
        if (element.statusInfo.status === CoSyncStatus.STATUS_CONFLICT) {
          conflictArray.value.push(element.coSyncInfo.localSyncId);
        }
      });
      if (conflictArray.value.length > 0) {
        CoSyncReporter.getInstance().reportConflictNotificationShow();
      }
      onSyncStatusMapChange(statusMap);
    };

    const sendsysNotifications = (syncServiceConfig: CoSyncInfo) => {
      const bodyText = i18n_t('【{slot1}】存在冲突，请及时处理', { slot1: getName(syncServiceConfig.config.syncPath) });
      sysNotifications.showNotifications(
        NotificationsType.TYPE_COSYNC_CONFLICT,
        i18n_t('同步冲突'),
        bodyText,
        '',
        true,
      );
    };

    const onSysNotificationsClick = (info: NotificationsCLickInfo) => {
      if (info.type !== NotificationsType.TYPE_COSYNC_CONFLICT) {
        return;
      }

      logger.ui.info('onSysNotificationsClick', info);
      onConfirm();
    };

    const onSyncStatusChange = (params?: any) => {
      const status = params as SyncTaskUIStatus;
      if (
        status.statusInfo.status === CoSyncStatus.STATUS_CONFLICT &&
        !conflictArray.value.includes(status.coSyncInfo.localSyncId)
      ) {
        if (conflictArray.value.length === 0) {
          CoSyncReporter.getInstance().reportConflictNotificationShow();
        }
        conflictArray.value.push(status.coSyncInfo.localSyncId);
        sendsysNotifications(status.coSyncInfo);
      } else if (
        status.statusInfo.status !== CoSyncStatus.STATUS_CONFLICT &&
        conflictArray.value.includes(status.coSyncInfo.localSyncId)
      ) {
        conflictArray.value = conflictArray.value.filter(id => id !== status.coSyncInfo.localSyncId);
      }
    };

    const onSyncStatusMapChange = (param?: Map<number, SyncTaskUIStatus>) => {
      if (conflictArray.value.length === 0) {
        return;
      }
      let statusMap = param;
      if (!statusMap) {
        statusMap = new Map<number, SyncTaskUIStatus>();
      }
      const conflictList = Array.from(statusMap)
        .filter(
          ([taskId, status]: [number, SyncTaskUIStatus]) => status.statusInfo.status === CoSyncStatus.STATUS_CONFLICT,
        )
        .map(([taskId, status]: [number, SyncTaskUIStatus]) => status);

      if (conflictList.length === 1) {
        let name = '';
        const coSyncInfo = conflictList.at(0)?.coSyncInfo;
        if (coSyncInfo) {
          name = getName(coSyncInfo.config.syncPath);
        }
        notificationContent.value = i18n_t('你的同步任务【{name}】存在冲突，请及时处理', { name });
      } else {
        notificationContent.value = i18n_t('你有{slot1}个同步任务存在冲突，请及时处理', { slot1: conflictList.length });
      }
    };

    const onTaskRemove = (params?: any) => {
      const { serviceId } = params;
      conflictArray.value = conflictArray.value.filter(id => id !== serviceId);
    };

    onMounted(() => {
      if (store.getters.isLogined) {
        initData(coSync.centerData().syncTaskStatusMap);
      }

      syncCenterEventBus.on(CoSyncCenterEvent.onTaskStatusChange, onSyncStatusChange);
      syncCenterEventBus.on(CoSyncCenterEvent.onTaskStatusMapChange, onSyncStatusMapChange);
      syncCenterEventBus.on(CoSyncCenterEvent.onTaskRemove, onTaskRemove);
      sysNotifications.on(SysNotificationsEevnet.EVENT_CLICK, onSysNotificationsClick);
    });

    onUnmounted(() => {
      sysNotifications.off(SysNotificationsEevnet.EVENT_CLICK, onSysNotificationsClick);
      syncCenterEventBus.off(CoSyncCenterEvent.onTaskStatusChange, onSyncStatusChange);
      syncCenterEventBus.off(CoSyncCenterEvent.onTaskStatusMapChange, onSyncStatusMapChange);
      syncCenterEventBus.off(CoSyncCenterEvent.onTaskRemove, onTaskRemove);
    });

    return { innerShow, onCancel, onConfirm, notificationContent };
  },
});
